// extracted by mini-css-extract-plugin
export default {"lyric":"LyricCardSample_lyric__y0+SN"};